<template>
  <MainTab :main-title="mainTitle" :confirm-button-text="confirmButtonText" :action="checkForm">
    <ContentWrapper :has-header-margin="false">
      <template #default>
        <div v-if="survey.completed" class="dea-survey">
          <form id="survey-form" action @submit.stop="submitSurvey">
            <RadioMultiSelect
              v-if="survey.general"
              group="general"
              :label="survey.general.label"
              :values="survey.general.values"
              :required="true"
              message="Campo obbligatorio"
              :value="surveyData.general"
              :validate="validate"
              @change="setSurveyItem"
            ></RadioMultiSelect>
            <RadioMultiSelect
              v-if="survey.previous"
              group="previous"
              :label="survey.previous.label"
              :values="survey.previous.values"
              :required="true"
              message="Campo obbligatorio"
              :value="surveyData.previous"
              :validate="validate"
              @change="setSurveyItem"
            ></RadioMultiSelect>
            <RadioMultiSelectMore
              v-if="survey.knowledge"
              group="knowledge"
              :label="survey.knowledge.label"
              :values="survey.knowledge.values"
              :value="surveyData.knowledge"
              :required="true"
              message="Campo obbligatorio"
              :validate="validate"
              input-text-type="text"
              @input="setSurveyItem"
            ></RadioMultiSelectMore>
            <h4 v-if="survey.eventEvaluationLabel" class="dea-heading--regular__m dea-survey__section-title">
              {{ survey.eventEvaluationLabel }}
            </h4>
            <div class="dea-survey__evaluation-section">
              <RadioMultiSelect
                v-if="survey.satisfy"
                group="satisfy"
                :label="survey.satisfy.label"
                :values="survey.satisfy.values"
                :required="true"
                :value="surveyData.satisfy"
                :validate="validate"
                message="Campo obbligatorio"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.speakers"
                group="speakers"
                :label="survey.speakers.label"
                :values="survey.speakers.values"
                :required="true"
                :value="surveyData.speakers"
                :validate="validate"
                message="Campo obbligatorio"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.coveredTopics"
                group="coveredTopics"
                :label="survey.coveredTopics.label"
                :values="survey.coveredTopics.values"
                :required="true"
                :value="surveyData.coveredTopics"
                :validate="validate"
                message="Campo obbligatorio"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.organization"
                group="organization"
                :label="survey.organization.label"
                :values="survey.organization.values"
                :required="true"
                :value="surveyData.organization"
                :validate="validate"
                message="Campo obbligatorio"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.location"
                group="location"
                :label="survey.location.label"
                :values="survey.location.values"
                :required="true"
                :value="surveyData.location"
                :validate="validate"
                message="Campo obbligatorio"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.topics"
                group="topics"
                :label="survey.topics.label"
                :values="survey.topics.values"
                :value="surveyData.topics"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <template v-if="activeRegistration().linked_event.type !== 'convention'">
                <RadioMultiSelect
                  v-if="survey.useful"
                  group="useful"
                  :label="survey.useful.label"
                  :values="survey.useful.values"
                  :value="surveyData.useful"
                  :required="true"
                  message="Campo obbligatorio"
                  :validate="validate"
                  @change="setSurveyItem"
                ></RadioMultiSelect>
              </template>
              <RadioMultiSelect
                v-if="survey.learning"
                group="learning"
                :label="survey.learning.label"
                :values="survey.learning.values"
                :value="surveyData.learning"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.guided"
                group="guided"
                :label="survey.guided.label"
                :values="survey.guided.values"
                :value="surveyData.guided"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.forum"
                group="forum"
                :label="survey.forum.label"
                :values="survey.forum.values"
                :value="surveyData.forum"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.suggest"
                group="suggest"
                :label="survey.suggest.label"
                :values="survey.suggest.values"
                :value="surveyData.suggest"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <h4 v-if="survey.schedule && survey.schedule.items.length" class="dea-heading--regular__m">
                {{ survey.schedule.label }}
              </h4>
              <div v-if="survey.schedule && survey.schedule.items.length">
                <RadioMultiSelect
                  v-for="(schedule, index) in survey.schedule.items"
                  :key="`schedule-${schedule.id}`"
                  :group="`schedule-${index}`"
                  :label="schedule.label"
                  :values="schedule.values"
                  :value="surveyData.schedule[index].value"
                  :required="true"
                  message="Campo obbligatorio"
                  :validate="validate"
                  @change="setSurveySchedule"
                ></RadioMultiSelect>
              </div>
              <h4
                v-if="survey.laboratories && survey.laboratories.items.length"
                class="dea-heading--regular__m dea-survey__section-title"
              >
                {{ survey.laboratories.label }}
              </h4>
              <Checkbox
                v-if="survey.laboratories && survey.laboratories.items.length"
                id="diffLabs"
                name="diffLabs"
                type="checkbox"
                :checked="diffLabs"
                @change="joinedDiffLabs"
              >
                HO SEGUITO LABORATORI DIVERSI RISPETTO A QUELLI A CUI MI ERO ISCRITTO/A
              </Checkbox>
              <div
                v-if="!diffLabs && survey.laboratories && survey.laboratories.items.length"
                class="dea-survey__laboratories-section"
              >
                <template v-for="(laboratory, index) in survey.laboratories.items">
                  <LaboratorySurveyItem
                    v-if="laboratory.id"
                    :key="`laboratory-${laboratory.id}`"
                    :group="`laboratory-${index}`"
                    :laboratory="laboratory"
                    :value="surveyData.laboratories[index].value"
                    :update-laboratory="setSurveyLab"
                    :update-question="setQuestionLab"
                    message="Campo obbligatorio"
                    :validate="!diffLabs && validate"
                    :required="!diffLabs"
                  ></LaboratorySurveyItem>
                </template>
              </div>
              <template v-if="activeRegistration().linked_event.type === 'convention'">
                <RadioMultiSelect
                  v-if="survey.useful"
                  group="useful"
                  :label="survey.useful.label"
                  :values="survey.useful.values"
                  :value="surveyData.useful"
                  :required="true"
                  message="Campo obbligatorio"
                  :validate="validate"
                  @change="setSurveyItem"
                ></RadioMultiSelect>
              </template>
              <RadioMultiSelect
                v-if="survey.support"
                group="support"
                :label="survey.support.label"
                :values="survey.support.values"
                :value="surveyData.support"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
              <RadioMultiSelect
                v-if="survey.analyze"
                group="analyze"
                :label="survey.analyze.label"
                :values="survey.analyze.values"
                :value="surveyData.analyze"
                :required="true"
                message="Campo obbligatorio"
                :validate="validate"
                @change="setSurveyItem"
              ></RadioMultiSelect>
            </div>
            <InputText
              v-if="survey.newTopic"
              id="newTopic"
              name="newTopic"
              type="text"
              placeholder="Scrivi qualcosa..."
              support-label="opzionale"
              :label="survey.newTopic.label"
              :value="surveyData.newTopic"
              @input="setSurveyInput($event, 'newTopic')"
            ></InputText>
            <template
              v-if="
                activeRegistration().linked_event.type === 'webinar' ||
                  activeRegistration().linked_event.type === 'seminar'
              "
            >
              <InputText
                v-if="survey.reviews"
                id="reviews"
                name="reviews"
                type="text"
                placeholder="Scrivi qualcosa..."
                support-label="opzionale"
                :label="survey.reviews.label"
                :value="surveyData.reviews"
                @input="setSurveyInput($event, 'reviews')"
              ></InputText>
              <Checkbox
                id="authorization"
                name="authorization"
                type="checkbox"
                :checked="authorizeReview"
                value="authorization"
                @change="switchAuthorizeReview"
              >
                {{ survey.authorization.label }}
              </Checkbox>
              <InputText
                v-if="survey.speakerQuestions"
                id="speakerQuestions"
                name="speakerQuestions"
                type="text"
                placeholder="Scrivi qualcosa..."
                support-label="opzionale"
                :label="survey.speakerQuestions.label"
                :value="surveyData.speakerQuestions"
                @input="setSurveyInput($event, 'speakerQuestions')"
              ></InputText>
            </template>
            <template v-else>
              <InputText
                v-if="survey.speakerQuestions"
                id="speakerQuestions"
                name="speakerQuestions"
                type="text"
                placeholder="Scrivi qualcosa..."
                support-label="opzionale"
                :label="survey.speakerQuestions.label"
                :value="surveyData.speakerQuestions"
                @input="setSurveyInput($event, 'speakerQuestions')"
              ></InputText>
              <InputText
                v-if="survey.reviews"
                id="reviews"
                name="reviews"
                type="text"
                placeholder="Scrivi qualcosa..."
                support-label="opzionale"
                :label="survey.reviews.label"
                :value="surveyData.reviews"
                @input="setSurveyInput($event, 'reviews')"
              ></InputText>
              <Checkbox
                id="authorization"
                name="authorization"
                type="checkbox"
                :checked="authorizeReview"
                value="authorization"
                @change="switchAuthorizeReview"
              >
                {{ survey.authorization.label }}
              </Checkbox>
            </template>
            <InputText
              v-if="survey.suggestions"
              id="suggestions"
              name="suggestions"
              type="text"
              placeholder="Scrivi qualcosa..."
              support-label="opzionale"
              :label="survey.suggestions.label"
              :value="surveyData.suggestions"
              @input="setSurveyInput($event, 'suggestions')"
            ></InputText>
          </form>
        </div>
        <Loader v-else></Loader>
      </template>
    </ContentWrapper>
  </MainTab>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import Checkbox from "@/components/elements/Checkbox";
import InputText from "@/components/elements/InputText";
import Loader from "@/components/elements/Loader";
import ModalAlert from "@/components/patterns/ModalAlert";
import ContentWrapper from "~/components/events/components/ContentWrapper";
import LaboratorySurveyItem from "~/components/events/components/LaboratorySurveyItem";
import MainTab from "~/components/events/components/MainTab";
import RadioMultiSelect from "~/components/shared/RadioMultiSelect";
import RadioMultiSelectMore from "~/components/shared/RadioMultiSelectMore";

export default {
  name: "EventsSurvey",
  components: {
    RadioMultiSelect,
    RadioMultiSelectMore,
    Checkbox,
    MainTab,
    ContentWrapper,
    LaboratorySurveyItem,
    InputText,
    Loader,
  },
  props: {
    mainTitle: {
      type: String,
      default: "",
    },
    confirmButtonText: {
      type: String,
      default: "Conferma",
    },
  },
  data() {
    return {
      localSurvey: {},
      validate: false,
      diffLabs: false,
      authorizeReview: false,
    };
  },
  computed: {
    ...mapGetters(["survey", "registrations", "surveyData", "activeRegistration"]),
  },
  mounted() {
    this.fetchAndCheck(this.$route.params.registration);
  },
  methods: {
    ...mapActions(["fetchRegistration", "setSurvey", "saveHomeSurvey"]),
    ...mapMutations([
      "setSurveyField",
      "setSurveyKey",
      "setSurveyScheduleKey",
      "setSurveyLabKey",
      "setSurveyQuestion",
      "setActiveRegistrationIndex",
    ]),
    async fetchAndCheck(registrationId) {
      await this.fetchRegistration({ registrationId, force: false });
      if (this.activeRegistration() && this.activeRegistration().survey_completed_date) {
        this.$router.push({ name: "certificate", params: { registration: this.activeRegistration().id } });
      }
    },
    checkForm() {
      const form = document.getElementById("survey-form");
      let valid = true;
      /* eslint-disable no-restricted-syntax */
      for (const field of form) {
        valid = valid && field.checkValidity();
      }
      /* eslint-enable no-restricted-syntax */

      this.validate = true;
      if (!valid) {
        ModalAlert.methods.setup(
          ModalAlert,
          "Valori mancanti",
          "Per favore completa le informazioni mancanti prima di procedere."
        );
      } else {
        try {
          this.saveHomeSurvey();
        } catch (e) {
          ModalAlert.methods.handleException(ModalAlert, this.$root.config, e);
        }
      }
    },
    setSurveyItem(event) {
      this.setSurveyKey({ item: event.target.name, value: event.target.value });
    },
    setSurveyInput(value, name) {
      this.setSurveyKey({ item: name, value });
    },
    setSurveySchedule(event) {
      const schedule = event.target.name.split("-")[1];
      this.setSurveyScheduleKey({ item: schedule, value: event.target.value });
    },
    setSurveyLab(event) {
      const laboratory = event.target.name.split("-")[1];
      this.setSurveyLabKey({ item: laboratory, value: event.target.value });
    },
    setQuestionLab(event) {
      const laboratory = event.target.name.split("-")[1];
      this.setSurveyQuestion({ item: laboratory, value: event.target.value });
    },
    joinedDiffLabs(event) {
      this.diffLabs = !this.diffLabs;
      this.setSurveyItem({ target: { name: event.target.name, value: event.target.checked } });
    },
    switchAuthorizeReview(event) {
      this.authorizeReview = !this.authorizeReview;
      this.setSurveyItem({ target: { name: event.target.name, value: event.target.checked } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/system.utils";

.dea-input,
.dea-multiselect,
.dea-yesnomore {
  margin-bottom: 1em;
  padding: 0;
  width: 100%;

  .dea-heading--regular__ms {
    padding-top: 0;
  }
}

.dea-survey {
  margin-bottom: $space-x-large;

  &__section-title {
    margin-bottom: $space-small;
    margin-top: $space-base;
  }

  &__evaluation-section {
    .dea-multiselect:not(:last-child) {
      margin-bottom: -$space-small;
    }
  }

  &__laboratories-section {
    margin-bottom: $space-base;
  }
}

.dea-modal-overlay {
  margin: 0 auto;
  position: fixed;
  top: 40vh;
}

.dea-input {
  padding-bottom: 14px;
}
</style>
